export default __webpack_public_path__ + "static/media/graph.61d4cd47.svg";